// extracted by mini-css-extract-plugin
module.exports = {"root":"_2c0358","placeHolder":"_346f15","select":"_851f53","icon":"_deb830"};